import { useEventBus } from '@byted/hooks';
import { DropdownDivider, Toast, Typography } from '@douyinfe/semi-ui';
import { Form, FormApi } from '@douyinfe/semi-ui/lib/es/form';
import { useRef } from 'react';
import { SylApi } from '@syllepsis/adapter';
import { useHistory } from '@jupiter/plugin-runtime/router';
import { EditorV2 } from '../EditorV2';
import { TitleFormItem } from './TitleFormItem';
import useBiz from '@/context/useBiz';
import {
  CreatePostRequest,
  CreatePostResponseData,
} from '@/typings/open.platform.forum_bff/namespaces/forumpost';
import { PostType } from '@/typings/fe';
import { useScope } from '@/hooks/useScope';
import { Biz } from '@/typings/open.platform.forum_bff/namespaces/configure';

type Props = {
  submitPost: (req: CreatePostRequest) => Promise<CreatePostResponseData>;
};

const NoticeMap: Record<Biz, string> = {
  [Biz.All]: '所有开发者',
  [Biz.Service]: '服务商',
  [Biz.Game]: '小游戏',
  [Biz.Open]: '小程序',
};

export const BulletinPost = ({ submitPost }: Props) => {
  const formRef = useRef<FormApi<{
    Title: string;
    notice: boolean;
    BizList: Biz[];
  }> | null>(null);
  const biz = useBiz(state => state.biz);
  const scope = useScope();
  const editorRef = useRef<SylApi | null>(null);
  const history = useHistory();
  useEventBus('POST_SUBMIT', async (type: PostType) => {
    if (type !== 'bulletin') {
      return;
    }

    const values = await formRef.current?.validate();
    if (!values) {
      return;
    }

    const html = editorRef.current?.getHTML();
    if (!html) {
      Toast.error('正文内容不能为空');
      return;
    }
    const meta: Record<string, string> = {};
    if (values.notice) {
      meta.publishNotification = 'true';
    }
    submitPost({
      Scope: scope,
      Biz: biz,
      Html: html,
      Title: values.Title,
      Meta: meta,
      Uid: '',
      Type: 'bulletin',
      BizList: values.BizList || [],
    });
  });

  return (
    <div className="bg-white px-8 py-6 mt-4 rounded-xl ">
      <Typography.Title heading={6}>基础信息</Typography.Title>
      <Form
        autoScrollToError={{
          skipOverflowHiddenElements: true,
          behavior: 'smooth',
        }}
        getFormApi={formApi => {
          formRef.current = formApi;
        }}
        render={({ values }) => (
          <>
            <TitleFormItem />
            <Form.RadioGroup
              field="Scope"
              type="pureCard"
              label={'发帖板块'}
              initValue={scope}
              onChange={value => {
                history.replace({
                  pathname: `/${value.target.value}/post/new`,
                });
              }}
              rules={[
                {
                  required: true,
                  message: '请选择发帖板块',
                },
              ]}>
              <Form.Radio value={'mini-app'}>小程序</Form.Radio>
              <Form.Radio value={'mini-game'}>小游戏</Form.Radio>
              {/* <Form.Radio value={'merchant'}>服务商</Form.Radio> */}
              {/* <Form.Radio value={'other'}>抖音其他开放能力</Form.Radio> */}
            </Form.RadioGroup>
            <Form.Switch
              initValue={false}
              field="notice"
              label={'发送通知'}
              rules={[
                {
                  required: true,
                },
              ]}
            />
            {values.notice && (
              <Form.Select
                label={'发送平台'}
                field="BizList"
                multiple={true}
                rules={[
                  {
                    required: true,
                    message: '请选择发送平台',
                  },
                ]}
                className={'min-w-[260px]  '}>
                {Object.keys(NoticeMap).map(key => (
                  <Form.Select.Option
                    key={key}
                    value={Number(key)}
                    label={NoticeMap[key as unknown as Biz]}
                  />
                ))}
              </Form.Select>
            )}

            <DropdownDivider className="my-8" />
            <Typography.Title heading={6}>文章正文</Typography.Title>
            <EditorV2
              className="mt-6"
              getEditorInstance={edtior => (editorRef.current = edtior)}
            />
          </>
        )}
      />
    </div>
  );
};
